import * as userActions from '../../reducers/user';
import Logger from '../../../services/Logger';
import sdk from '../../../sdk';
import Toast from '../../../components/Toast';
import l18n from '../../../shared/strings';

export const DISABLE_TEAMMATES_NOTIFICATIONS = 'disableTeammatesNotifications';

/**
 * Turns the team default "notifications off for teammates" on or off.
 * Updates the store first and rolls back when the request fails.
 * @param {boolean} value
 * @returns {Promise<boolean>} whether the setting was saved
 */
const saveTeamNotificationDefaults = (value) => async (dispatch, getState) => {
  const { user } = getState();
  const prevValue = user.team?.settings?.[DISABLE_TEAMMATES_NOTIFICATIONS];
  const strings = l18n.NOTIFICATION_SETTINGS.matrix.teamDefaults;

  dispatch(userActions.updateTeamSetting({ key: DISABLE_TEAMMATES_NOTIFICATIONS, value }));

  try {
    await sdk.team.setNotificationDefaults(value);
    if (value) Toast(strings.toastDisabled, { type: 'success' });
    return true;
  } catch (err) {
    dispatch(userActions.updateTeamSetting({ key: DISABLE_TEAMMATES_NOTIFICATIONS, value: prevValue }));
    Logger.error(new Error('Can not update team notification defaults'), { error: err }, [
      'UpdateTeamNotificationDefaultsFailed',
      { errorMessage: (err && err.message) || 'NoMessage' },
    ]);
    Toast(strings.errorSaving, { type: 'error' });
    return false;
  }
};

export default saveTeamNotificationDefaults;
